import { HttpHandler } from 'msw'

import { hatch } from './hatch'

export const distributors: HttpHandler[] = [...hatch]
